<template lang="pug">
  bloco#contato.-padding-desktop
    //- HEADER
    header(slot="header")
      titulo.-withbar.-upper Contato
    //- CONTENT
    .conteudo(slot="content")
      p.phone (84) 3215-3305 / 3208
      p.email secretariaproad@reitoria.ufrn.br
      p.infos Para mais informações, dúvidas e/ou sugestões entre em contato através do formulário abaixo:
      formulario(:destino="'proad'")
</template>

<style lang="scss">
  #contato {

    .phone,
    .email,
    .infos {
      margin: 15px 0;
    }

    .phone:before,
    .email:before {
      font-family: 'FontAwesome';
      font-size: 22px;
      vertical-align: middle;
      color: $color-blue-dark;
      margin-right: 1em;
      width: 19px;
      text-align: center;
    }

    .phone:before { content: '\f095' }
    .email:before { content: '\f0e0' }

    > .conteudo {
      .buttons {
        margin-top: 30px;
        text-align: center;
        > .btn {
          margin: 0 11px;
          min-height: 40px;
          min-width: 100px;
        }
      }
    }

    @include media(">=tablet","<desktop") {
      > .conteudo { padding: 0 2rem }
    }
    @include media(">=desktop") {
      > .conteudo { padding: 0 2rem }
    }

    @include media("print") {
      > .conteudo { display: none }
    }
  }
</style>

<script>
  import Bloco from 'COMPONENTS/Bloco'
  import Formulario from 'COMPONENTS/Formulario'
  import Mensagem from 'COMPONENTS/Mensagem'
  import Titulo from 'COMPONENTS/ContentTitle'
  export default {
    components: {
      Bloco,
      Formulario,
      Mensagem,
      Titulo }
  }
</script>



// WEBPACK FOOTER //
// Contato.vue?e529d8d0